import NonFeasibleMessage from './NonFeasibleMessage.styled';

export default NonFeasibleMessage;
